import React from 'react';
import i18next from 'i18next';
import {NavLink} from 'react-router-dom';
import BtnGroup from '../BtnGroup/BtnGroup';
import ButtonIcon from '../Button/ButtonIcon';

import gameCrashIcon from 'icons/game-crash.svg';
import gameEsport from 'icons/game-esport.svg';
import gameSlotsIcon from 'icons/game-slots.svg';

class GameNav extends React.Component {
    render() {
        const {slotsEnabled} = this.props;
        return (
            <div className="game-nav">
                <div className="game-nav__left">
                    <span>{i18next.t('game_nav.type')}</span>
                    <BtnGroup>
                        <NavLink to="/"
                                 isActive={(match, location) =>
                                     location.pathname === '/' ||
                                     location.pathname.startsWith('/crash/')
                                 }
                        >
                            <ButtonIcon glyph={gameCrashIcon}>
                                {i18next.t('game_nav.crash')}
                            </ButtonIcon>
                        </NavLink>
                        <NavLink exact to="/esports">
                            <ButtonIcon glyph={gameEsport}>
                                {i18next.t('game_nav.esports')}
                            </ButtonIcon>
                        </NavLink>
                        {slotsEnabled && (
                            <NavLink exact to="/slots">
                                <ButtonIcon glyph={gameSlotsIcon}>
                                    {i18next.t('game_nav.slots')}
                                </ButtonIcon>
                            </NavLink>
                        )}
                    </BtnGroup>
                </div>

                <div className="game-nav__right"/>
            </div>
        );
    }
}

export default GameNav;



// WEBPACK FOOTER //
// ./app/components/GameNav/GameNav.jsx